/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCollectorHealthStatus200Response
 */
export interface GetCollectorHealthStatus200Response {
    /**
     * `ok` — collector is healthy; `restart` — collector should restart itself.
     */
    status?: GetCollectorHealthStatus200ResponseStatusEnum;
}


/**
 * @export
 */
export const GetCollectorHealthStatus200ResponseStatusEnum = {
    Ok: 'ok',
    Restart: 'restart',
} as const;
export type GetCollectorHealthStatus200ResponseStatusEnum = typeof GetCollectorHealthStatus200ResponseStatusEnum[keyof typeof GetCollectorHealthStatus200ResponseStatusEnum];


/**
 * Check if a given object implements the GetCollectorHealthStatus200Response interface.
 */
export function instanceOfGetCollectorHealthStatus200Response(value: object): value is GetCollectorHealthStatus200Response {
    return true;
}

export function GetCollectorHealthStatus200ResponseFromJSON(json: any): GetCollectorHealthStatus200Response {
    return GetCollectorHealthStatus200ResponseFromJSONTyped(json, false);
}

export function GetCollectorHealthStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCollectorHealthStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function GetCollectorHealthStatus200ResponseToJSON(json: any): GetCollectorHealthStatus200Response {
    return GetCollectorHealthStatus200ResponseToJSONTyped(json, false);
}

export function GetCollectorHealthStatus200ResponseToJSONTyped(value?: GetCollectorHealthStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

